module.exports = __webpack_public_path__ + "Flama-Light.woff?6e44f49569e6dc6a32b5307869a7dfae";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Light.woff
// module id = 930
// module chunks = 0